module.exports = __webpack_public_path__ + "static/img/23066B_1_2_R_20230715_LC.5f06c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/23066B_1_2_R_20230715_LC.png
// module id = cNLt
// module chunks = 0